import React from 'react';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import SEO from '../components/SEO';
import LockPhonePage from '../pages/LockPhonePage';
import { useTranslation } from 'react-i18next';

export const LockPhone = () => {
  const { t, i18n } = useTranslation();

  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t('Bloqueo de Smartphone para equipos a crédito')}
        description={t('Asegura celulares financiados con nuestro candado digital. Implementa bloqueo remoto y reduce cartera moratoria con soluciones financieras innovadoras.')}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/device-lock' : 'bloqueo-dispositivos'}`}
        hreflang={[
          { url: "https://dynamicore.io/bloqueo-dispositivos", lang: "es" },
          { url: "https://dynamicore.io/en/device-lock", lang: "en-us" }
        ]}
      />
      <LockPhonePage/>
    </Layout>
  )
}
